export const NEWFLEET = "newFleet";
export const EDITFLEET = "editFleet";
